import { request } from "@weapp/utils";
import { LockParams } from "../components/page/lock/pc/types";
import { getTerminalType } from "../utils";

export const invokeUnlock = (data: LockParams) => {
  return request({
    url: `/api/basicserver/lockPage/awakenPage?timestamp=${new Date().getTime()}`,
    method: "post",
    data: { ...data }
  });
};

export const unlock = (client: string) => {
  return request({
    url: `/api/basiconline/online/disLockPage`,
    method: "GET",
    params: {
      // eteamsIds: [window.ETEAMSID],
      dtu: client === 'true' ? 'app-pc' : 'pc',
      touchDtu: getTerminalType()
    }
  });
};

export const lock = (client: boolean) => {
  return request({
    url: `/api/basiconline/online/lockPage`,
    method: "GET",
    params: {
      // eteamsIds: [window.ETEAMSID],
      dtu: client ? 'app-pc' : 'pc',
      touchDtu: getTerminalType()
    }
  });
};
